"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRecognitionLoginRequest = void 0;
var ClientRecognitionLoginRequest = /** @class */ (function () {
    function ClientRecognitionLoginRequest() {
    }
    return ClientRecognitionLoginRequest;
}());
exports.ClientRecognitionLoginRequest = ClientRecognitionLoginRequest;
;
//# sourceMappingURL=clientRecognitionLogin.request.js.map